export default "__VITE_ASSET__b5b849bb__"